class ReiandoContactPage {
  constructor(section) {
    this.section = section;

    this.form = section.querySelector(
      '[data-reiando-contact-form]'
    );

    this.inputScreen = section.querySelector(
      '[data-reiando-contact-input]'
    );

    this.confirmationScreen = section.querySelector(
      '[data-reiando-contact-confirmation]'
    );

    this.confirmationTitle = section.querySelector(
      '[data-reiando-contact-confirmation-title]'
    );

    this.confirmButton = section.querySelector(
      '[data-reiando-contact-confirm-button]'
    );

    this.backButton = section.querySelector(
      '[data-reiando-contact-back-button]'
    );

    this.submitButton = section.querySelector(
      '[data-reiando-contact-submit-button]'
    );

    this.fields = Array.from(
      section.querySelectorAll(
        '[data-reiando-contact-field]'
      )
    );

    this.outputs = Array.from(
      section.querySelectorAll(
        '[data-reiando-contact-output]'
      )
    );

    this.isConfirmationVisible = false;
    this.isSubmitting = false;

    this.handleConfirm =
      this.handleConfirm.bind(this);

    this.handleBack =
      this.handleBack.bind(this);

    this.handleSubmit =
      this.handleSubmit.bind(this);

    this.bindEvents();
  }

  bindEvents() {
    this.confirmButton?.addEventListener(
      'click',
      this.handleConfirm
    );

    this.backButton?.addEventListener(
      'click',
      this.handleBack
    );

    this.form?.addEventListener(
      'submit',
      this.handleSubmit
    );
  }

  handleConfirm() {
    if (!this.form) {
      return;
    }

    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    this.updateConfirmationValues();
    this.showConfirmation();
  }

  updateConfirmationValues() {
    this.outputs.forEach((output) => {
      const fieldName =
        output.dataset.reiandoContactOutput;

      const field = this.fields.find((item) => {
        return (
          item.dataset.reiandoContactField ===
          fieldName
        );
      });

      if (!field) {
        output.textContent = '';
        return;
      }

      output.textContent =
        field.value.trim();
    });
  }

  showConfirmation() {
    if (
      !this.inputScreen ||
      !this.confirmationScreen
    ) {
      return;
    }

    this.inputScreen.hidden = true;
    this.confirmationScreen.hidden = false;
    this.isConfirmationVisible = true;

    this.confirmationTitle?.focus();

    window.scrollTo({
      top:
        this.section.getBoundingClientRect().top +
        window.scrollY,
      behavior: 'smooth'
    });
  }

  handleBack() {
    if (
      !this.inputScreen ||
      !this.confirmationScreen
    ) {
      return;
    }

    this.confirmationScreen.hidden = true;
    this.inputScreen.hidden = false;
    this.isConfirmationVisible = false;

    const firstField = this.fields[0];

    window.scrollTo({
      top:
        this.section.getBoundingClientRect().top +
        window.scrollY,
      behavior: 'smooth'
    });

    window.setTimeout(() => {
      firstField?.focus();
    }, 300);
  }

  handleSubmit(event) {
    if (!this.form) {
      return;
    }

    /*
     * Enterキーなどで確認画面を飛ばして
     * 直接送信されることを防止
     */
    if (!this.isConfirmationVisible) {
      event.preventDefault();
      this.handleConfirm();
      return;
    }

    if (!this.form.checkValidity()) {
      event.preventDefault();
      this.form.reportValidity();
      return;
    }

    if (this.isSubmitting) {
      event.preventDefault();
      return;
    }

    this.isSubmitting = true;

    if (this.submitButton) {
      this.submitButton.disabled = true;
      this.submitButton.textContent = '送信中...';
    }
  }

  destroy() {
    this.confirmButton?.removeEventListener(
      'click',
      this.handleConfirm
    );

    this.backButton?.removeEventListener(
      'click',
      this.handleBack
    );

    this.form?.removeEventListener(
      'submit',
      this.handleSubmit
    );
  }
}

function initializeReiandoContactPage(
  root = document
) {
  const sections = [];

  if (
    root instanceof Element &&
    root.matches('[data-reiando-contact]')
  ) {
    sections.push(root);
  }

  root
    .querySelectorAll?.(
      '[data-reiando-contact]'
    )
    .forEach((section) => {
      sections.push(section);
    });

  sections.forEach((section) => {
    if (
      section.dataset
        .reiandoContactInitialized ===
      'true'
    ) {
      return;
    }

    section.dataset
      .reiandoContactInitialized =
      'true';

    section.reiandoContactPage =
      new ReiandoContactPage(section);
  });
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    initializeReiandoContactPage();
  }
);

document.addEventListener(
  'shopify:section:load',
  (event) => {
    initializeReiandoContactPage(
      event.target
    );
  }
);

document.addEventListener(
  'shopify:section:unload',
  (event) => {
    const section =
      event.target.matches?.(
        '[data-reiando-contact]'
      )
        ? event.target
        : event.target.querySelector(
            '[data-reiando-contact]'
          );

    if (!section?.reiandoContactPage) {
      return;
    }

    section.reiandoContactPage.destroy();
  }
);